import axios from "axios";

import ConvertObjectParamToString from "@/commons/ConvertObjectParamToString";

const SearchReceipt = "/api/business/receipts/declarations";
const SearchReceiptHis = "/api/business/receipts/declarations/histories";
const ExcelReceiptHis = "/api/business/receipts/declarations/export";
export default class receiptSettlementService {
    private convertObjectParamToStrings: ConvertObjectParamToString = ConvertObjectParamToString.instance;

    public getSearchReceipt(querySearch): Promise<any> {
        return new Promise<any>((resolve, reject) => {
          axios
            .get(SearchReceipt + "?" + this.convertObjectParamToStrings.convertObjectParamToStrings(querySearch))
            .then((res) => {
              resolve(res.data);
            })
            .catch((err) => {
              reject(err);
            });
        });
      }
    
      public ChotReceiptFee(querySearch?: any): Promise<any> {
        return new Promise<any>((resolve, reject) => {
          axios
            .post(SearchReceipt, querySearch)
            .then((res) => {
              resolve(res);
            })
            .catch((err) => {
              reject(err);
            });
        });
      }

      public getSearchReceiptHis(querySearch): Promise<any> {
        return new Promise<any>((resolve, reject) => {
          axios
            .get(SearchReceiptHis + "?" + this.convertObjectParamToStrings.convertObjectParamToStrings(querySearch))
            .then((res) => {
              resolve(res.data);
            })
            .catch((err) => {
              reject(err);
            });
        });
      }

      public getSearchListReceiptHis(id): Promise<any> {
        return new Promise<any>((resolve, reject) => {
          axios
            .get(SearchReceipt + '/' + id)
            .then((res) => {
              resolve(res.data);
            })
            .catch((err) => {
              reject(err);
            });
        });
      }  

      public getExcelListReceiptHis(param,querySearch): Promise<any> {
        return new Promise<any>((resolve, reject) => {
          axios
            .post(ExcelReceiptHis + "?" + this.convertObjectParamToStrings.convertObjectParamToStrings(param), querySearch ,{ responseType: 'blob' })
            .then((res) => {
              resolve(res);
            })
            .catch((err) => {
              reject(err);
            });
        });
      }
}